// extracted by mini-css-extract-plugin
module.exports = {"grid":"_2Td_x","gridcell":"bDfMI","row":"_2VBm0"};